import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './utils/theme';
import { MainLayout } from './components/layout';
import { Home, About, Ministries, MinistryDetail, Schools, SchoolDetail, Events, EventDetail, Store, Checkout, OrderSuccess, NotFound } from './components/pages';
import QRLanding from './components/pages/QRLanding';
import { ToastProvider } from './components/ui';
import { configurationService } from './services';
import { useConfigurationInitialization } from './hooks';
import './utils/i18n';
import './styles/globals.css';

function App() {
  // Initialize all configurations with persistence
  useConfigurationInitialization();

  useEffect(() => {
    // Initialize configuration service on app startup
    configurationService.initialize();
  }, []);

  return (
    <ThemeProvider>
      <ToastProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Routes>
            {/* QR Landing - Standalone without MainLayout */}
            <Route path="/qr" element={<QRLanding />} />
            
            {/* Main website routes with MainLayout */}
            <Route path="/*" element={
              <MainLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/ministries" element={<Ministries />} />
                  <Route path="/ministries/:ministryId" element={<MinistryDetail />} />
                  <Route path="/schools" element={<Schools />} />
                  <Route path="/schools/:schoolKey/:schoolId" element={<SchoolDetail />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/events/:eventKey/:eventId" element={<EventDetail />} />
                  <Route path="/store" element={<Store />} />
                  <Route path="/store/product/:productId" element={<Store />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-success" element={<OrderSuccess />} />
                  {/* Explicit 404 route */}
                  <Route path="/404" element={<NotFound />} />
                  {/* 404 Catch-all route - must be last */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </MainLayout>
            } />
          </Routes>
        </Router>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;